import { mapActions, mapGetters, mapMutations } from 'vuex'
import globalConfig from '../utiles/globalConfig'
import { scrollTop } from '../utiles/index'

export const isTiktok = globalConfig.getHrefParam('pt') == 'tiktok'
export default {
  data() {
    let gameLoginInfoResolve = () => {}
    const gameLoginInfoPromise = new Promise(resolve => {
      gameLoginInfoResolve = resolve
    })
    return {
      gameLoginInfoResolve,
      gameLoginInfoPromise,
      isTiktok: isTiktok, // 是否是Tiktok平台
      isLoadingPay: false, // 是否正在支付
      gameLoginParams: {
        uid: '',
        timestamp: '',
        sign: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'letter',
      'gameId',
      'platform',
      'lang',
      'serverId',
      'roleId',
      'roleName',
      'sdkParams',
      'userName',
      'userId',
      'gclid',
      'cid',
      'scid',
      'fbc',
      'fbp',
      'adid',
      'adname',
      'camid',
      'camname',
      'adsetid',
      'adsetname',
      'originUserType'
    ])
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'judgeIsLogin',
      'refreshUserJson',
      'touristLogin',
      'tiktokLogin',
      'tiktokProductList',
      'submitTiktokPay',
      'getCurGclid'
    ]),
    sendMessageToTiktok(action, param = {}) {
      window.parent.postMessage(
        {
          action,
          param
        },
        '*'
      )
    },
    async loadGameLink() {
      this.getGameLink().then(async data => {
        const hadParamsGameLink = `https:${data}`
        const url = new URL(hadParamsGameLink)
        this.gameLoginParams.uid = url.searchParams.get('uid')
        this.gameLoginParams.timestamp = url.searchParams.get('timestamp')
        this.gameLoginParams.sign = url.searchParams.get('sign')

        this.gameLoginInfoResolve()

        this.sendMessageToTiktok('tiktok_log', {
          logValue: JSON.stringify(this.gameLoginParams)
        })
      })
      scrollTop()
      this.getCurGclid().then(() => {
        globalConfig.ajaxStatistics({
          eventName: 'login',
          eventType: 'custom_loss',
          loginAccount: this.userName,
          userId: this.userId,
          gclid: this.gclid,
          cid: this.cid,
          scid: this.scid,
          fbc: this.fbc,
          fbp: this.fbp,
          adid: this.adid,
          adname: this.adname,
          camid: this.camid,
          camname: this.camname,
          adsetid: this.adsetid,
          adsetname: this.adsetname
        })
      })
    },
    async tiktok_startLoadMainPackage() {
      this.sendMessageToTiktok('tiktok_h5LoadingFinished')
    },
    async tiktok_finishLoadMainPackage() {
      await this.gameLoginInfoPromise
      this.$refs.curGamePage.contentWindow.postMessage(
        {
          action: 'login',
          params: {
            ...this.gameLoginParams
          }
        },
        '*'
      )
    },
    async tiktok_loginH5ByCode({ code }) {
      const clientKey = globalConfig.getHrefParam('clientKey')
      const params = {
        clientKey,
        code,
        gameId: this.gameId,
        packageName: globalConfig.getHrefParam('packageName')
      }
      let errorMsg = ''
      try {
        const data = await this.tiktokLogin(params)
        this.sendMessageToTiktok('tiktok_log', {
          logValue: JSON.stringify(data)
        })
        const loginRs = await this.judgeIsLogin({
          isCheck: true,
          isFirst: false
        })
        if (loginRs) {
          this.loadGameLink()
        } else {
          this.sendMessageToTiktok('tiktok_showToast', {
            message: this.letter.fb_canvas_login_fail,
            duration: 2000
          })
        }
      } catch (e) {
        console.error(e)
        this.sendMessageToTiktok('tiktok_showToast', {
          message: e.msg,
          duration: 2000
        })
      }
      this.tiktok_ajaxStatistics({
        eventName: 'codelogin',
        eventType: 'custom_codelogin_callback',
        eventValue: errorMsg
      })
    },
    // 开发使用
    async loginTiktok() {
      const clientKey = globalConfig.getHrefParam('clientKey')
      const code = globalConfig.getHrefParam('code')
      const params = {
        clientKey,
        code,
        gameId: this.gameId,
        packageName: globalConfig.getHrefParam('packageName')
      }
      try {
        const data = await this.tiktokLogin(params)
        this.sendMessageToTiktok('tiktok_log', {
          logValue: JSON.stringify(data)
        })

        const loginRs = await this.judgeIsLogin({
          isCheck: true,
          isFirst: false
        })
        if (loginRs) {
          this.loadGameLink()
        }
      } catch (e) {
        console.error(e)
        // 如果ticket并且过期了重新使用code登录
        this.sendMessageToTiktok('tiktok_showToast', {
          message: e.msg,
          duration: 2000
        })
      }
    },
    async tiktokPay(sdkParam) {
      if (this.isLoadingPay) return
      this.isLoadingPay = true
      this.sdkParam = sdkParam
      this.sendMessageToTiktok('tiktok_getPayCode')
    },
    async doTiktokPay(params) {
      const sdkParam = this.sdkParam
      try {
        this.sendMessageToTiktok('tiktok_showLoading')
        const productData = await this.tiktokProductList({
          game_id: this.gameId,
          f_pay_type: 'tiktok',
          pay_type: 'tiktok',
          currency: 'BEANS',
          serverId: sdkParam.serverId,
          roleId: sdkParam.roleId,
          roleName: encodeURIComponent(sdkParam.roleName),
          h5: 1
        })
        this.sendMessageToTiktok('tiktok_log', {
          logValue: JSON.stringify(productData)
        })
        const productItem = productData.find(
          item => item.PRODUCT_ID === sdkParam.productId
        )
        const submitParams = {
          ticket: params.code,
          productId: sdkParam.productId,
          cpProductId: sdkParam.cpProductId,
          productDesc: sdkParam.productName,
          localMoney: productItem.TRANS_AMOUNT,
          localCurrency: productItem.CURRENCY,
          cpOrderId: sdkParam.order_no,
          serverId: sdkParam.serverId,
          roleId: sdkParam.roleId,
          remark: sdkParam.remark,
          roleName: encodeURIComponent(sdkParam.roleName),
          packageName: globalConfig.getHrefParam('packageName'),
          userId: this.userId,
          gameId: this.gameId,
          f_pay_type: 'tiktok',
          paytype: 'tiktok',
          location: 'ID',
          ptCode: 'global',
          pageSource: 'h5',
          isWeb: '1',
          devicePlate: 'pc'
        }
        if (globalConfig.getHrefParam('test') == 1) {
          submitParams.configKey = 'sandbox'
        }
        const submitData = await this.submitTiktokPay(submitParams)
        this.sendMessageToTiktok('tiktok_log', {
          logValue: JSON.stringify(submitData)
        })
        this.sendMessageToTiktok('tiktok_pay', {
          tradeOrderId: submitData.transaction_id
        })
      } catch (e) {
        console.error(e)
        this.sendMessageToTiktok('tiktok_showToast', {
          message: e.msg,
          duration: 2000
        })
      }
      this.sendMessageToTiktok('tiktok_hideLoading')
      this.isLoadingPay = false
    },
    openTiktokWebview(url) {
      this.$store.commit('updateAsidePopupState', false)
      if (!/^(http|https):/.test(url)) {
        url = `https:${url}`
      } else if (/^http:/.test(url)) {
        url = url.replace('http:', 'https:')
      }
      this.$store.commit('updateAsideCustomerPageState', {
        visible: true,
        link: globalConfig.hrefAddParams(url, {
          //  添加自定义参数，目前没有先空着
        })
      })
    },
    tiktok_ajaxStatistics(params) {
      globalConfig.ajaxStatistics({
        eventName: params.eventName,
        eventType: params.eventType,
        eventValue: params.eventValue || '',
        loginAccount: this.userName,
        userId: this.userId,
        gclid: this.gclid,
        cid: this.cid,
        scid: this.scid,
        fbc: this.fbc,
        fbp: this.fbp,
        adid: this.adid,
        adname: this.adname,
        camid: this.camid,
        camname: this.camname,
        adsetid: this.adsetid,
        adsetname: this.adsetname
      })
    }
  }
}
